/**
 * Réordonne une liste d'ids (indices inclus).
 * Retourne le tableau d'origine si les indices sont invalides ou identiques.
 */
export function u3204ReorderIds(ids: string[], fromIndex: number, toIndex: number): string[] {
  if (
    fromIndex === toIndex ||
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= ids.length ||
    toIndex >= ids.length
  ) {
    return ids;
  }
  const next = [...ids];
  const [removed] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, removed);
  return next;
}

/** Déplace un id d'un cran (Monter / Descendre). */
export function u3204MoveIdInList(
  ids: string[],
  index: number,
  direction: 'up' | 'down',
): string[] {
  const target = direction === 'up' ? index - 1 : index + 1;
  return u3204ReorderIds(ids, index, target);
}

/**
 * Fusionne un nouvel ordre visible dans l'ordre complet des épinglées.
 * Les ids hors vue conservent leur interleaving (filtre mission / texte).
 */
export function u3204MergePinnedReorderIds(
  fullOrderedIds: string[],
  visibleNextOrderedIds: string[],
): string[] {
  const visibleSet = new Set(visibleNextOrderedIds);
  let visibleIndex = 0;
  return fullOrderedIds.map((id) => {
    if (!visibleSet.has(id)) {
      return id;
    }
    const nextId = visibleNextOrderedIds[visibleIndex];
    visibleIndex += 1;
    return nextId ?? id;
  });
}
